import { render, staticRenderFns } from "./ProjectImage.vue?vue&type=template&id=a56d121a&scoped=true&"
import script from "./ProjectImage.vue?vue&type=script&lang=js&"
export * from "./ProjectImage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectImage.vue?vue&type=style&index=0&id=a56d121a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56d121a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
